import type { SVGProps } from 'react'
const SvgSySolana = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" width={24} height={24} {...props}>
		<path d="M774.8 376.8H24.7c-22.4 0-22.4 22.7 0 50.7l115.7 144.9c22.4 28 58.6 50.7 81 50.7h750.2c22.4 0 22.4-22.7 0-50.7L855.8 427.5c-22.3-28-58.6-50.7-81-50.7M221.3 740.4h750.2c22.4 0 22.4 22.7 0 50.7L855.8 936c-22.4 28-58.6 50.7-81 50.7H24.7c-22.4 0-22.4-22.7 0-50.7l115.7-144.9c22.3-28 58.6-50.7 80.9-50.7m0-727.3h750.2c22.4 0 22.4 22.7 0 50.7L855.8 208.7c-22.4 28-58.6 50.7-81 50.7H24.7c-22.4 0-22.4-22.7 0-50.7L140.3 63.8c22.4-28 58.7-50.7 81-50.7" />
	</svg>
)
export default SvgSySolana
